import { IPageContent } from "api/interfaces/static-content.type";
import NewPageHeader from "component/banner/NewPageHeader";
import { deepFind } from "../../../util/helper/deepFind";
import { DEFAULT_MAKE_MODEL_BANNER } from "./make-model-year-utils";
import styles from "./related-products.module.scss";

interface IProps{
  staticContent: IPageContent;
}

function PageHeaderDesktop(props: IProps) {
  const {
    pageDetails, fallbackImage, staticContent,
    fitmentOptionsDetails, fitmentOptionsPrompt, // makeUrl, vehicle,
    breadCrumbsV2,

  } = props;

  const { bannerDescription } = staticContent;
  const { pageDisplayableTitle } = pageDetails || {};

  return (

    <div className={styles.page_header_banner_container}>
      <NewPageHeader
        fitmentOptionsDetails={fitmentOptionsDetails}
        fitmentOptionsPrompt={fitmentOptionsPrompt}
        staticContent={staticContent}
        bannerData={{
          bannerImageUrl: deepFind(pageDetails, "bannerImageUrl", fallbackImage),
          fallbackImage: DEFAULT_MAKE_MODEL_BANNER,
        }}
        description={bannerDescription || ""}
        pageDisplayableTitle={pageDisplayableTitle}
        breadCrumbsV2={breadCrumbsV2}
        showBreadCrumb
      />
    </div>

  );
}

export default PageHeaderDesktop;
